import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { SocialProof } from './components/SocialProof';
import { OfferStack } from './components/OfferStack';
import { PriceSection } from './components/PriceSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalClose } from './components/FinalClose';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-offwhite font-sans selection:bg-gold-500/30 selection:text-gold-500" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main className="pt-10" data-id="element-2">
        {' '}
        {/* Padding top to account for sticky urgency bar */}
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <SocialProof data-id="element-7" />
        <OfferStack data-id="element-8" />
        <PriceSection data-id="element-9" />
        <FaqSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FinalClose data-id="element-12" />
      </main>
    </div>;
}